import React from "react";
import AdminLogs from "../components/AdminLogs";
import useAdminLogs from "../hooks/useAdminLogs";

const AdminLogsInterface = () => {
  const {
    logs,
    lines,
    since,
    container,
    loading,
    error,
    onRefreshLogs,
    onLinesChange,
    onSinceChange,
  } = useAdminLogs();

  return (
    <AdminLogs
      logs={logs}
      lines={lines}
      since={since}
      container={container}
      loading={loading}
      error={error}
      onRefreshLogs={onRefreshLogs}
      onLinesChange={onLinesChange}
      onSinceChange={onSinceChange}
    />
  );
};

export default AdminLogsInterface;
